import CollapsibleWidget from './CollapsibleWidget'

export default CollapsibleWidget
